import React, { Fragment, useEffect, useMemo, useReducer } from 'react';
import produce from 'immer';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { StylesProvider } from '@material-ui/styles';
import { ThemeProvider as SCThemeProvider, createGlobalStyle } from 'styled-components';
import { UPDATE_THEME_TYPE, defaultTheme, THEME } from './constants';
import { createExtendedTheme, setCSSVariables } from './utils';
import * as styleTypes from './themes';
const themes = styleTypes.default;
// set default theme for cert-app and other non dashboard applications
// ensure the supplied theme exists, otherwise fall back on the defined defaultTheme
const storedTheme = localStorage.getItem(THEME) || defaultTheme;

const getThemeOptions = themeType => themes[themeType] ? themes[themeType] : themes[storedTheme];

function themeReducer(draft, action) {
  switch (action.type) {
    case UPDATE_THEME_TYPE:
      draft.themeOptions = getThemeOptions(action.payload.themeType);
      break;

    default:
  }
}

const curriedThemeReducer = produce(themeReducer);
const GlobalStyles = createGlobalStyle`
  ${props => props.suppressGlobal ? '' : props.global}
  ${props => props.globalStyles}
  `;

const Wrapper = ({
  children,
  suppressGlobal,
  global,
  globalStyles
}) => /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(GlobalStyles, {
  suppressGlobal: suppressGlobal,
  global: global,
  globalStyles: globalStyles
}), suppressGlobal ? /*#__PURE__*/React.createElement(Fragment, null, children) : /*#__PURE__*/React.createElement(CssBaseline, null, children));

const ThemeProvider = ({
  theme: themeType,
  globalStyles: initGlobalStyles,
  suppressGlobal,
  injectFirst,
  children
}) => {
  // TODO: create theme context to pass 'dispatch'
  const selectedTheme = localStorage.getItem(THEME) || themeType;
  const initialThemeState = {
    globalStyles: initGlobalStyles,
    themeOptions: getThemeOptions(selectedTheme)
  };
  const [{
    globalStyles,
    themeOptions
  }, dispatch] = useReducer(curriedThemeReducer, initialThemeState);
  const theme = useMemo(() => {
    const localTheme = createExtendedTheme(themeOptions);
    setCSSVariables(localTheme);
    return localTheme;
  }, [themeOptions]);
  useEffect(() => {
    dispatch({
      type: UPDATE_THEME_TYPE,
      payload: {
        themeType: selectedTheme
      }
    });
  }, [selectedTheme]);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    injectFirst: injectFirst
  }, /*#__PURE__*/React.createElement(SCThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(MuiThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Wrapper, {
    suppressGlobal: suppressGlobal,
    global: themeOptions.global,
    globalStyles: globalStyles
  }, React.Children.only(children)))));
};

const testable = {
  themeReducer
};
export { themes, testable };
export default ThemeProvider;